export default __webpack_public_path__ + "static/englet-6-5e42e1a4ab5ee6315f20c9d4f5bf39e9.jpg";